var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarlyAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16666 2.5L1.66666 5M18.3333 5L15.8333 2.5M5 15.8333L3.33333 17.5M15 15.8333L16.6667 17.5M7.5 11.25L9.16666 12.9167L12.9167 9.16667M10 17.5C11.7681 17.5 13.4638 16.7976 14.714 15.5474C15.9643 14.2971 16.6667 12.6014 16.6667 10.8333C16.6667 9.06522 15.9643 7.36953 14.714 6.11929C13.4638 4.86905 11.7681 4.16667 10 4.16667C8.23189 4.16667 6.5362 4.86905 5.28595 6.11929C4.03571 7.36953 3.33333 9.06522 3.33333 10.8333C3.33333 12.6014 4.03571 14.2971 5.28595 15.5474C6.5362 16.7976 8.23189 17.5 10 17.5Z",
    stroke: "#7E5AE2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyAccess);
export default __webpack_public_path__ + "static/media/early_access.99f92334122be224de14c7dafa0caced.svg";
export { ForwardRef as ReactComponent };